import { render, staticRenderFns } from "./instrument.vue?vue&type=template&id=015f3b70&"
import script from "./instrument.vue?vue&type=script&lang=js&"
export * from "./instrument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports